import React, { useState } from "react";
import ViewButton from "../Buttons/ViewButton";
import AddButtonRound from "../Buttons/AddButtonRound";
import CheckWithDate from "../CheckWithDate";
import { Box, Modal, Slide } from "@mui/material";
import ViewInformedConsent from "../forms/ViewInformedConsent";

function FormLineIC(props) {
  const [showViewModal2, setShowViewModal2] = useState(false);

  const openViewModal2 = () => {
    setShowViewModal2(true);
  };

  const closeViewModal2 = () => {
    setShowViewModal2(false);
  };

  return (
    <div
      style={{
        marginLeft: "0px",
        display: "flex",
        flexDirection: "row",
        height: "50px",
        borderRadius: "30px",
        border: "1px solid lightgrey",
        width: "40%",
        marginTop: "5px",
        marginBottom: "5px",
        paddingLeft: "15px",
        paddingRight: "5px",
      }}
    >
      <Modal open={showViewModal2} onClose={closeViewModal2}>
        <Slide direction="left" in={showViewModal2}>
          <Box
            sx={{
              position: "fixed",
              top: "5%",
              right: 0,
              width: "30%",
              height: "90%",
              bgcolor: "background.paper",
              boxShadow: 24,
              marginRight: "15px",
              pl: 0,
              pr: 0,
              borderRadius: "15px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ViewInformedConsent {...props} closemodal={closeViewModal2} />
          </Box>
        </Slide>
      </Modal>

      <div
        style={{
          width: "60%",
          fontSize: "18px",
          fontWeight: "600",
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        {props.title}
      </div>
      <div
        style={{
          width: "30%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {props.signed ? (
          <CheckWithDate checked={true} content={props.date} />
        ) : (
          <CheckWithDate checked={false} content="Not signed" />
        )}
      </div>

      <div
        style={{
          width: "10%",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        {props.signed ? (
          <ViewButton handleOpen2={openViewModal2} {...props} />
        ) : (
          <AddButtonRound handleOpen={props.handleOpen} />
        )}
      </div>
    </div>
  );
}

export default FormLineIC;
